/* eslint-disable react/prop-types */
import React, { useRef } from 'react'
import { Box } from '@mui/material'
import MessagingForm from '../../Forms/MessagingForm'
import Footer from './Footer'
import SectionHeadline from '../../../../Header/SectionHeadline'

export function MessagingSection({ listing }) {
  const formRef = useRef(null)

  return (
    <div style={{ position: 'relative' }}>
      <Box>
        <Box><SectionHeadline>Customize Messaging</SectionHeadline></Box>
        <Box><MessagingForm innerRef={formRef} listing={listing} isWizard={false} /></Box>
        <Box><Footer label="Save" onSubmit={() => formRef.current.requestSubmit()} /></Box>
      </Box>
    </div>
  )
}

export default MessagingSection
